import React from 'react';
import bounceBack from '../assets/bounceback.svg';
import { Image } from 'react-bootstrap';
import {
  PRODUCT_NAME
} from '../constants/constants';

function Logo({ onClick }) {
  return (
    <Image
      fluid
      src={bounceBack}
      alt={PRODUCT_NAME}
      onClick={onClick}
      style={{ padding: 10 }}
      data-testid="logo"
    />
  );
}

export default Logo;
